<template>
  <div class="login-shell">
    <div class="login-bg">
      <div class="login-bg__orb login-bg__orb--a"></div>
      <div class="login-bg__orb login-bg__orb--b"></div>
    </div>

    <main class="login-card">
      <div class="login-card__brand">
        <img src="../assets/NYC_logo.png" alt="Logo" class="login-card__logo" />
        <div>
          <span class="login-card__eyebrow">指导师沟通平台</span>
          <h1>指导师沟通平台</h1>
        </div>
      </div>

      <form class="login-form" @submit.prevent="handleLogin">
        <div class="login-field">
          <label class="login-field__label">账号</label>
          <div class="login-field__input-wrap">
            <svg class="login-field__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <input
              v-model="form.username"
              type="text"
              class="login-field__input"
              placeholder="请输入工号或手机号"
              autocomplete="username"
            />
          </div>
        </div>

        <div class="login-field">
          <label class="login-field__label">密码</label>
          <div class="login-field__input-wrap">
            <svg class="login-field__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            <input
              v-model="form.password"
              :type="showPassword ? 'text' : 'password'"
              class="login-field__input"
              placeholder="请输入密码"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="login-field__toggle"
              :aria-label="showPassword ? '隐藏密码' : '显示密码'"
              @click="showPassword = !showPassword"
            >
              <svg v-if="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>
        </div>

        <div class="login-options">
          <label class="login-checkbox">
            <input type="checkbox" v-model="form.remember" />
            <span>记住账号</span>
          </label>
          <a class="login-link" href="#">忘记密码？</a>
        </div>

        <button type="submit" class="login-submit" :disabled="loading">
          <span v-if="!loading">登 录</span>
          <span v-else class="login-submit__loading">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10" stroke-dasharray="31" stroke-dashoffset="10"><animateTransform attributeName="transform" type="rotate" values="0 12 12;360 12 12" dur="0.8s" repeatCount="indefinite"/></circle></svg>
          </span>
        </button>

        <div class="login-divider">
          <span class="login-divider__line"></span>
          <span class="login-divider__text">或</span>
          <span class="login-divider__line"></span>
        </div>

        <button type="button" class="login-wecom" @click="handleWecomLogin">
          <svg width="20" height="20" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.66 3.24c8.44 0 15.3 5.94 15.3 13.3 0 .27-.01.53-.03.8l-.01.16-.12-.11a3.07 3.07 0 0 0-3.04-.6l-.11.04v-.54c-.19-5.47-5.49-9.89-12-9.89-1.36 0-2.66.19-3.88.54l-.51.16C6.81 8.6 3.66 12.29 3.66 16.58c0 3.02 1.56 5.74 4.04 7.61l.11.1a1.08 1.08 0 0 1 .32.8l-.02.15-.42 2.39a.21.21 0 0 0 .3.21l2.75-1.59.1-.05c.24-.1.51-.12.76-.04l.48.14c1.18.34 2.42.51 3.58.51 1.38 0 2.73-.2 4.12-.62l.09-.03.01.09a3.08 3.08 0 0 0 1.96 2.35l.2.08-.2.07A17.22 17.22 0 0 1 15.66 33a17.38 17.38 0 0 1-4.55-.6l-4.54 2.22a1.15 1.15 0 0 1-1.65-1.16l.41-3.95C2.28 23.92.36 20.43.36 16.55.36 9.18 7.22 3.24 15.66 3.24z" fill="#0082EF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M30.35 18.13c.38.38.59.86.64 1.36h.003a5.51 5.51 0 0 0 1.7 3.36l.03.03a.56.56 0 0 1-.01.78.55.55 0 0 1-.78.01l-.03-.03c-.04-.04-.08-.08-.11-.12a5.56 5.56 0 0 0-3.22-1.58 2.25 2.25 0 0 1-1.38-.64 2.22 2.22 0 0 1 0-3.15 2.22 2.22 0 0 1 3.15 0z" fill="#2DBC00"/><path fill-rule="evenodd" clip-rule="evenodd" d="M36.33 27.13a2.2 2.2 0 0 1-1.36.64h-.003a5.55 5.55 0 0 0-3.24 1.59c-.04.04-.08.08-.11.12l-.03.03a.56.56 0 0 1-.78-.01.55.55 0 0 1-.01-.78l.03-.03c.04-.04.08-.08.12-.11a5.56 5.56 0 0 0 1.58-3.22 2.25 2.25 0 0 1 .64-1.38 2.22 2.22 0 0 1 3.15 0 2.22 2.22 0 0 1 0 3.15z" fill="#0082EF"/><path fill-rule="evenodd" clip-rule="evenodd" d="M27.33 33.11a2.2 2.2 0 0 1-.64-1.36h-.003a5.51 5.51 0 0 0-1.59-3.25c-.04-.03-.08-.07-.12-.11l-.03-.03a.56.56 0 0 1 .01-.78.55.55 0 0 1 .78-.01l.03.03c.04.04.08.08.11.12a5.56 5.56 0 0 0 3.23 1.58 2.25 2.25 0 0 1 1.38.64 2.22 2.22 0 0 1 0 3.15 2.22 2.22 0 0 1-3.15 0z" fill="#FB6500"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.34 24.11a2.2 2.2 0 0 1 1.36-.64h.002a5.55 5.55 0 0 0 3.24-1.59c.04-.04.08-.08.11-.12l.03-.03a.56.56 0 0 1 .78.01.55.55 0 0 1 .01.78l-.03.03c-.04.04-.08.08-.12.11a5.56 5.56 0 0 0-1.58 3.23 2.25 2.25 0 0 1-.64 1.38 2.22 2.22 0 0 1-3.15 0 2.22 2.22 0 0 1 0-3.15z" fill="#FC0"/></svg>
          <span>企业微信扫码登录</span>
        </button>

        <p v-if="errorMsg" class="login-error">{{ errorMsg }}</p>
      </form>

      <footer class="login-card__footer">
        <span>© 2026 指导师沟通平台 · 企微家长沟通管理系统</span>
      </footer>
    </main>
  </div>
</template>

<script>
import { login, getWecomLoginUrl } from '@/api'
import { useUserStore } from '@/store/user'

const roleHomeMap = {
  ADMIN: '/admin',
  CENTER_LEAD: '/',
  DEPT_LEAD: '/',
  MANAGER: '/control-tower-two'
}

export default {
  name: 'LoginView',
  data() {
    return {
      form: {
        username: '',
        password: '',
        remember: false
      },
      showPassword: false,
      loading: false,
      errorMsg: ''
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)
    const wecomError = params.get('wecomError')
    if (wecomError) {
      this.errorMsg = wecomError
    }
  },
  methods: {
    async handleWecomLogin() {
      try {
        const res = await getWecomLoginUrl()
        if (res.code === 200 && res.data?.url) {
          window.location.href = res.data.url
        } else {
          this.errorMsg = '获取登录链接失败'
        }
      } catch (err) {
        this.errorMsg = '获取登录链接失败'
      }
    },
    async handleLogin() {
      this.errorMsg = '';
      if (!this.form.username.trim()) {
        this.errorMsg = '请输入账号';
        return;
      }
      if (!this.form.password) {
        this.errorMsg = '请输入密码';
        return;
      }
      this.loading = true;
      try {
        const res = await login({
          username: this.form.username,
          password: this.form.password
        });
        if (res.code === 200 && res.data) {
          const userStore = useUserStore();
          userStore.setUser(res.data);
          this.$router.push(roleHomeMap[res.data.highestRole] || '/');
        } else {
          this.errorMsg = res.message || '登录失败，请检查账号密码';
        }
      } catch (err) {
        this.errorMsg = err?.response?.data?.message || '登录失败，请检查账号密码';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 20px;
  color: var(--ink);
  background:
    radial-gradient(circle at left top, rgba(41, 107, 115, 0.16), transparent 22%),
    radial-gradient(circle at 86% 8%, rgba(210, 140, 40, 0.16), transparent 18%),
    linear-gradient(135deg, #f8f4ec 0%, var(--bg) 48%, var(--bg-strong) 100%);
  font-family: "Aptos", "PingFang SC", "Microsoft YaHei UI", sans-serif;
}

.login-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
}

.login-bg__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
}

.login-bg__orb--a {
  width: 500px;
  height: 500px;
  top: -120px;
  left: -100px;
  background: rgba(41, 107, 115, 0.12);
}

.login-bg__orb--b {
  width: 400px;
  height: 400px;
  bottom: -80px;
  right: -60px;
  background: rgba(210, 140, 40, 0.10);
}

.login-card {
  position: relative;
  width: 100%;
  max-width: 420px;
  padding: 36px 32px 28px;
  border: 1px solid rgba(29, 47, 44, 0.08);
  background: var(--surface);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow);
  backdrop-filter: blur(12px);
}

.login-card__brand {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}

.login-card__logo {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: contain;
}

.login-card__eyebrow {
  display: block;
  font-size: 0.68rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-soft);
  margin-bottom: 2px;
}

.login-card__brand h1 {
  margin: 0;
  font-size: 1.4rem;
  font-family: "Avenir Next", "PingFang SC", "Microsoft YaHei UI", sans-serif;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.login-field__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: 0.04em;
}

.login-field__input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  height: 46px;
  border: 1px solid rgba(34, 58, 53, 0.14);
  border-radius: 14px;
  background: rgba(255, 250, 244, 0.6);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.login-field__input-wrap:focus-within {
  border-color: var(--brand);
  box-shadow: var(--focus-ring);
}

.login-field__icon {
  flex-shrink: 0;
  color: var(--ink-soft);
}

.login-field__input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
  color: var(--ink);
  font-family: inherit;
}

.login-field__input::placeholder {
  color: rgba(92, 110, 104, 0.6);
}

.login-field__toggle {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: var(--ink-soft);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: background 160ms ease;
}

.login-field__toggle:hover {
  background: rgba(41, 107, 115, 0.08);
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--ink-soft);
  cursor: pointer;
}

.login-checkbox input {
  accent-color: var(--brand);
}

.login-link {
  font-size: 0.78rem;
  color: var(--brand);
  text-decoration: none;
  font-weight: 500;
}

.login-link:hover {
  text-decoration: underline;
}

.login-submit {
  height: 46px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--brand), var(--brand-strong));
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease;
  font-family: inherit;
}

.login-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(41, 107, 115, 0.3);
}

.login-submit:active:not(:disabled) {
  transform: translateY(0);
}

.login-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-submit__loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.login-error {
  margin: 0;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(203, 97, 69, 0.12);
  color: var(--danger);
  font-size: 0.82rem;
  text-align: center;
}

.login-divider {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-divider__line {
  flex: 1;
  height: 1px;
  background: rgba(34, 58, 53, 0.12);
}

.login-divider__text {
  font-size: 0.75rem;
  color: rgba(92, 110, 104, 0.6);
}

.login-wecom {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  border: 1px solid rgba(34, 58, 53, 0.14);
  border-radius: 14px;
  background: rgba(255, 250, 244, 0.6);
  color: var(--ink);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease;
  font-family: inherit;
}

.login-wecom:hover {
  border-color: var(--brand);
  background: rgba(41, 107, 115, 0.06);
}

.login-card__footer {
  margin-top: 28px;
  text-align: center;
  font-size: 0.68rem;
  color: rgba(92, 110, 104, 0.6);
}

@media (max-width: 480px) {
  .login-shell {
    padding: 16px;
    align-items: flex-start;
    padding-top: 60px;
  }

  .login-card {
    padding: 28px 20px 24px;
    border-radius: 20px;
  }

  .login-card__brand h1 {
    font-size: 1.2rem;
  }

  .login-field__input-wrap {
    height: 42px;
  }

  .login-submit {
    height: 42px;
    font-size: 0.88rem;
  }
}
</style>
